import {Component, Input} from '@angular/core';
import {DynamicForm} from "../../core/dynamic-form";

@Component({
    selector: 'inf-form',
    template: `
    <form [formGroup]="form.form" (ngSubmit)="onSubmit(form.model)">
      <formly-form [form]="form.form" [fields]="form.fields" [options]="form.options" [model]="form.model"></formly-form>
    </form>
  `,
    styles: [`
    form {
      overflow: auto;

      ::ng-deep mat-radio-button {
        margin: 0px 16px 16px 0px;
      }
    }
  `],
    standalone: false
})
export class FormComponent {

  @Input() form = new DynamicForm();

  onSubmit(model: any) {
    // alert(model);
  }
}
